// removed by extract-text-webpack-plugin
module.exports = {"container":"jk_g","tooltip":"jk_jl","heartButtonText":"jk_jm","heartButtonTextSaved":"jk_jn","saveButton":"jk_jo _1kB_d9laDuyaX1azPOvneD","heartContainer":"jk_jp","blackHeart":"jk_jq jk_jo _1kB_d9laDuyaX1azPOvneD","whiteHeart":"jk_jr jk_jo _1kB_d9laDuyaX1azPOvneD","whiteAndRedHeart":"jk_js jk_jo _1kB_d9laDuyaX1azPOvneD","redHeart":"jk_jt jk_jo _1kB_d9laDuyaX1azPOvneD","counter":"jk_hp"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/HeartButton/styles.module.css
// module id = 1150
// module chunks = 27